/**
 * Sorts items by a custom sort order array.
 * Items not in the sort order are placed at the end, preserving their original order.
 *
 * Used for sorting upsale groups by upsalesSortOrder.
 */
export const sortUpsales = <T extends { id: string }>(items: T[], sortOrder: string[]): T[] => {
  return [...items].sort((a, b) => {
    const indexA = sortOrder.indexOf(a.id);
    const indexB = sortOrder.indexOf(b.id);

    // Items not in sortOrder go to the end, preserving their original order
    if (indexA === -1 && indexB === -1) return 0;
    if (indexA === -1) return 1;
    if (indexB === -1) return -1;
    return indexA - indexB;
  });
};
